webpackJsonp([219557871318718],{

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(17);
	
	var _Layout = __webpack_require__(64);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _Layout2.default,
	    null,
	    _react2.default.createElement(_components.PageTitle, { title: '\u8D44\u8D28\u8363\u8A89' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-honor-js-b18d40f92e2594df82ba.js